import { B2bSavingPlanCategoryCustomProduct } from '@Common/types/b2b/plans';
import { EmployeeSavingsRiskProfile } from '@Common/types/profile/employee_savings';

import { makeChoicesCommon } from '@sh4res/bo-common/utils';

export const SICAV_COMPATIBLE_CATEGORIES: B2bSavingPlanCategoryCustomProduct[] = [
  'PERECO',
  'PERECOG',
];

export const investorProfileRiskProfileChoices = makeChoicesCommon<EmployeeSavingsRiskProfile>()({
  balanced: 'resources.bo_common.b2b.investor_profile.risk_profile.balanced',
  careful: 'resources.bo_common.b2b.investor_profile.risk_profile.careful',
  dynamic: 'resources.bo_common.b2b.investor_profile.risk_profile.dynamic',
  sicav: 'resources.bo_common.b2b.investor_profile.risk_profile.sicav',
});

export const classicInvestorProfileRiskProfileChoices = makeChoicesCommon<
  Exclude<EmployeeSavingsRiskProfile, 'sicav'>
>()({
  balanced: 'resources.bo_common.b2b.investor_profile.risk_profile.balanced',
  careful: 'resources.bo_common.b2b.investor_profile.risk_profile.careful',
  dynamic: 'resources.bo_common.b2b.investor_profile.risk_profile.dynamic',
});

export const investorProfileProductCategoryChoices = makeChoicesCommon<
  Extract<B2bSavingPlanCategoryCustomProduct, 'PEE' | 'PERECO' | 'PEEG' | 'PERECOG' | 'PERCO'>
>()({
  PEE: 'resources.bo_common.b2b.companies.saving_plans.types.PEE',
  PERECO: 'resources.bo_common.b2b.companies.saving_plans.types.PERECO',
  PEEG: 'resources.bo_common.b2b.companies.saving_plans.types.PEEG',
  PERECOG: 'resources.bo_common.b2b.companies.saving_plans.types.PERECOG',
  PERCO: 'resources.bo_common.b2b.companies.saving_plans.types.PERCO',
});
